export const FAIL_STATUS = 3;
export const SUCCESS_STATUS = 2;
export const COMPANY_METHOD = 3;
export const BANK_CARD_METHOD = 2;
export const ALIPAY_METHOD = 1;
export const REFUND_STATUS = 6;

export const STATUS_MAP = {
  1: '提现中',
  [SUCCESS_STATUS]: '提现成功',
  [FAIL_STATUS]: '提现失败',
  [REFUND_STATUS]: '主动取消提现',
};

export const TYPE_MAP = {
  [ALIPAY_METHOD]: '支付宝',
  [BANK_CARD_METHOD]: '银行卡',
  [COMPANY_METHOD]: '公司账户',
};

export const INVOICE_MAP = {
  0: '未提供',
  1: '已提供',
};

export const statusMap = {
  1: '提现中',
  2: '提现成功',
  3: '提现失败',
};

export const typeMap = {
  1: '支付宝',
  2: '银行卡',
  3: '公司账户',
};

// 认证类型 (1-个人 2-企业)
export const AUTH_TYPE = {
  PERSONAL: 1,
  ENTERPRISE: 2,
};

// 状态（0-未认证，1-认证中，2-认证成功，3-认证失败）
export const AUTH_STATE_MAP = {
  NONE: 0,
  ING: 1,
  SUCCESS: 2,
  FAIL: 3,
  CLEAR: 4,
};

// payment支付方式
export const PAYMENT_TYPE = {
  ALIPAY: 1,
  BANK: 2,
  ENTERPRISE: 3,
};
// 原始页面，ORIGIN_WITHDRAWAL是提现页面，ORIGIN_VERIFY是验证码页面
export const ORIGIN_WITHDRAWAL = 0;
export const ORIGIN_VERIFY = 1;

// 提现的状态
export const RESULT_ING = 1;
export const RESULT_SUCEESS = 2;
export const RESULT_FAIL = 3;

// 认证类型，2银行上传身份证，3二要素认证
export const TYPE_ALIPAY = 3;
export const TYPE_BANK = 2;

// 默认手续费，获取配置失败时使用
export const DEFAULT_FEE_RATE = 0.07;
export const DEFAULT_EXTRA_FEE = 100;

//  发送短信验证码使用场景
export const DARW_ZFB = 1001; //ZFB
export const DARW_YHK = 1002; //银行卡
export const SYNC_AUTH_PER = 1101; //同步个人实名信息短信场景标识

export const API_CODE_UNKNOWN = -100000000; // 状态码未知，可能是网络错误
export const API_CODE_SUCCESS = 0; // 成功
export const API_CODE_SESSION_ERROR = -11004; // 登录态失效
export const API_CODE_FORCED_UPGRADE = -10400; // 需要强制升级
export const API_CODE_BIND_CEILING = -10500; // 添加成功,绑定设备已达到上限
export const API_CODE_NEED_SMS = -10305; // 提现时需要校验短信验证码
export const API_CODE_GROUP_CEILING = -10602; // 添加分组失败，分组数量超过上限
export const API_CODE_AUTH_UN_MATCH = -10312; //提现信息和实名不一致
export const API_CODE_NONE_INVOICE = -10313; //上个月提现发票未提供致
export const API_CODE_NONE_INVOICE2 = -10315; //上个月之前提现发票未提供
export const API_CODE_ERROR_VERIFY = -10100; //验证码错误
export const API_CODE_DRAW_RISK_CONTROL = -10325; // 提现额度风控
export const PAGE_SIZE = 20;

export const companyRules = [
  {
    title: '提现方式',
    content:
      '使用认证信息里的开户银行对公转账，提现将于提现日后两个工作日内到账。如超时未到账，请联系银行客服检查账户状态是否封禁、限制收款等。',
  },
  {
    title: '提现时间',
    content: '每周二（10:00-18:00）可进行提现，如遇节假日顺延至下周。',
  },
  {
    title: '提现限制',
    content: '银行账户一旦确认不支持变更。',
  },
  {
    title: '提现发票',
    content: `
    <p>企业提现完成后，下月提现前需提供本月增值税专用发票，否则将无法提现，发票详细内容如下： </p>
    <ul style="padding-left: 0.2rem">
    <li>
    <p><strong>(1) 发票内容：</strong></p>
      <p><strong>选择发票类目流程：</strong>*电信服务*其他增值电信服务*技术服务费；*现代服务*信息系统服务*信息技术服务费；或者其他符合税法规定的发票内容 — ***（第三级类目根据个人情况自行编写）</p>
      <p><strong>公司名称：</strong>深圳市网心科技有限公司</p>
      <p><strong>税号：</strong>91440300053965375W</p>
      <p><strong>社会信用代码：</strong>91440300053965375W</p>
      <p><strong>地址、电话：</strong>深圳市前海深港合作区前湾一路1号A栋201室（入驻深圳市前海商务秘书有限公司）<br/>0755-86240911</p>
      <p><strong>开户银行及账号：</strong>招商银行深圳蛇口支行755920273010903</p>
    </li>
    <li><strong>(2) 发票提供时间：</strong>每个自然月最后一次提现后的五日内需快递到网心科技 （例如6月份的发票需在7月5日前寄到网心科技，7月份的发票需在8月2日前寄到网心科技），我方将在收到发票后的7个工作日内审核完成，发票验证合格后，可继续提现，若延迟提供将影响您的提现进度；</li>
    <li><strong>(3) 开票金额必须与当月的提现金额完全一致且准确到分，如5386.26元；</strong></li>
    <li>
        <p><strong>(4) 增值税专用发票需快递至网心科技（请使用顺丰快递，其他快递易丢件，影响提现进度；拒签到付或平邮件，敬请谅解），收件信息：</p>
        <p><strong>收件人：</strong>网心云发票组  <br/><strong>联系电话：</strong>13632795680<strong>（仅供收件使用，咨询请联系在线客服）</strong></p>
        <p><strong>收件地址：</strong>深圳市南山区粤海街道高新区社区科技南路18号深圳湾科技生态园12栋B座23层（推荐顺丰，其他快递易丢件，若快递丢失需复印件加盖发票专用章，重新邮寄）</p>
    </li>
    <li>
    <strong>(5) 其他问题请联系官网<a href="/#" id="service-button">在线客服</a>（9：00-22：00）</strong>
    </li>
    </ul>`,
  },
];

export const TEMP_PERSONAL_RULE = [
  {
    title: '提现时间：',
    content: '每周二（10-00--18:00）可进行提现，如遇节假日则顺延至下周。',
  },
  {
    title: '提现方式与金额：',
    content: `<ul>
        <li>无提现额度限制，用户可根据提现金额选择适合的提现方式。</li>
        <li>
          ①
          每月低于800元的提现，支持支付宝、银行卡提现，支付宝提现免费，银行卡提现每笔将扣除7%+1元的服务费；
        </li>
        <li>② 每月高于800元的提现，支持银行卡提现，每笔提现将扣除7%+1元的服务费。</li>
      </ul>`,
  },
];

export const getPersonRules = (withdrawRule = {}) => {
  const { extraFee, feeRate } = withdrawRule;
  const defaultText = 0;
  const resExtraFee = extraFee ? extraFee / 100 : defaultText;
  const resFeeRate = feeRate ? (feeRate * 100).toFixed(2) : defaultText;
  const resExtraFeeText = resExtraFee ? `+${resExtraFee}元` : '';
  // const fixedRate = 6;
  // const resRate = feeRate ? (resFeeRate - 6).toFixed(2) : defaultText;
  const personRules = [
    {
      title: '提现时间',
      content: '每周二（10:00--18:00）可进行提现，如遇节假日顺延至下周。',
    },
    {
      title: '提现方式',
      content: `<ul>
        <li>
        用户可根据提现金额选择适合的提现方式：
        </li>
        <li>
        ① 每月提现不超过800元时，支持支付宝（推荐）、银行卡提现，支付宝提现免费，银行卡提现每笔将扣除${resFeeRate}%${resExtraFeeText}的服务费；
        </li>
        <li>
        ② 每月提现高于800元时，支持银行卡提现，每笔提现将扣除${resFeeRate}%${resExtraFeeText}的服务费。
        </li>
        </ul>`,
    },
    {
      title: '温馨提示',
      content:
        '您的提现取得的收入，我们将会按税法规定代扣代缴个人所得税，因此您需提供个人有效身份证信息和真实姓名。',
    },
  ];
  return personRules;
};

export const DEFAULT_TEXT = 0;
